import { ClientUserState } from '../../ClientUserState.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
export function isSubscriptionOverlayVariant() {
    return ClientUserState.abTests.SUBSCRIPTION_OVERLAY == 'SHOW_SUBSCRIPTION_OVERLAY';
}
export function isSubscriptionOverlayVisible() {
    const overlayContainer = document.querySelector('.subscription-overlay-container');
    if (overlayContainer == null) return false;
    return !overlayContainer.classList.contains('hidden');
}
export function openSubscriptionOverlayInsteadOfLinkInVariant(storeLinkButton) {
    if (!isSubscriptionOverlayVariant()) return;
    storeLinkButton.removeAttribute('href');
    // eslint-disable-next-line no-restricted-syntax
    storeLinkButton.addEventListener('click', ()=>uiManagerEvents.premiumMembershipCheckAction());
}
